import React from 'react'
import cn from 'classnames'
import { Badge } from '@mc/design-system'
import { Trans, useTranslation } from '@mc/i18n'
import { BenefitTrans, TableHeader, type PlansTier } from '@mc/plans-ui'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../../i18n'
import { MC_PRO_TIER_I18N_NAMESPACE } from '../../../i18n'
import { useTierColumns } from './Table'
import classes from './DesktopMatrix.module.scss'

const Headline = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)

  return (
    <div role='cell' className={classes.headline}>
      <h1 className='mc-text-h3 mc-mb-3'>{t('plans.title')}</h1>
      <span className='mc-text-color--light'>
        <Trans i18nKey='plans.subtitleShort' ns={CHECKOUT_I18N_NAMESPACE}>
          <span className='mc-text--bold' />
        </Trans>
      </span>
      <hr aria-hidden className={classes.headlineBar} />
    </div>
  )
}

const AccountAndDevices = ({ tier }: { tier: PlansTier }) => {
  const { t } = useTranslation(MC_PRO_TIER_I18N_NAMESPACE)

  return (
    <>
      {t('matrix.headers.oneAccount')}
      <br />
      <BenefitTrans
        ns={CHECKOUT_I18N_NAMESPACE}
        i18nKey='plans.headers.devicesInfo'
        tier={tier}
        name='concurrent_devices'
      />
    </>
  )
}

const ProDescription = () => {
  const { t } = useTranslation(MC_PRO_TIER_I18N_NAMESPACE)

  return (
    <>
      {t('matrix.headers.everythingInPremium')}
      <br />
      {t('matrix.headers.plusAllCertificates')}
    </>
  )
}

export const Header = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const columns = useTierColumns()

  return (
    <div role='row' className={classes.row}>
      <Headline />
      {columns.map(({ tier, isSelected, onSelect, isPro }, index) => (
        <div
          key={index}
          role='columnheader'
          aria-current={isSelected}
          className={cn(classes.tierHeader, {
            [classes.selected]: isSelected,
          })}
        >
          {isPro && (
            <Badge className='mc-mb-4'>{t('plans.headers.bestValue')}</Badge>
          )}
          <p className='mc-text-h5 mc-mb-2'>{tier.displayName}</p>
          <span className='d-block mc-text-h8 mc-text--normal mc-mb-4'>
            {isPro ? <ProDescription /> : <AccountAndDevices tier={tier} />}
          </span>
          <TableHeader.SelectButton
            isSelected={isSelected}
            onClick={onSelect}
            label={t('plans.headers.cta.label', { plan: tier.displayName })}
            selectedLabel={t('plans.headers.cta.selected')}
            unselectedLabel={t('plans.headers.cta.select')}
          />
        </div>
      ))}
    </div>
  )
}
